import loadable from '@loadable/component';
import { Loading } from '_component';

const Home = loadable(() => import('custom-itinerary/Index'), {
  fallback: <Loading />,
});
const ViewOrder = loadable(() => import('custom-itinerary/viewOrder/Index'), {
  fallback: <Loading />,
});
const Prefer = loadable(() => import('custom-itinerary/prefer/Index'), {
  fallback: <Loading />,
});
const ModifyTour = loadable(() => import('custom-itinerary/modifyTour/Index'), {
  fallback: <Loading />,
});
const Expense = loadable(() => import('custom-itinerary/expense/Index'), {
  fallback: <Loading />,
});
const Requirement = loadable(
  () => import('custom-itinerary/requirement/Index'),
  { fallback: <Loading /> },
);
const Contact = loadable(() => import('custom-itinerary/contact/Index'), {
  fallback: <Loading />,
});

export const ROUTES = [
  { path: '/custom-itinerary', element: <Home /> },

  // AI生成路線
  { path: '/custom-itinerary/prefer', element: <Prefer /> },
  { path: '/custom-itinerary/modifyTour', element: <ModifyTour /> },
  { path: '/custom-itinerary/requirement', element: <Requirement /> },

  // 推薦行程路線
  { path: '/custom-itinerary/:id', element: <Requirement /> },
  { path: '/custom-itinerary/expense', element: <Expense /> },

  // 通用:聯絡資訊
  { path: '/custom-itinerary/contact', element: <Contact /> },

  // 通用:訂單結果
  { path: '/custom-itinerary/viewOrder/:id', element: <ViewOrder /> }, // 填寫需求單後的版本
  { path: '/custom-itinerary/view/:id', element: <ViewOrder /> }, // 從官網訂單資訊查看的版本
  { path: '/custom-itinerary/order', element: <ViewOrder /> }, // AI生成行程的版本

  // 通配符路由
  { path: '*', element: <Home /> },
];
